/* @flow */

import moment from 'moment';

export default class AddCompanyUBORequest {
  companyId: number;
  titleId: number;
  firstName: string;
  lastName: string;
  email: string;
  addressLine1: string;
  addressLine2: string;
  zipCode: string;
  city: string;
  countryId: number;
  nationalityId: number;
  birthCountryId: number;
  birthDate: moment;
  birthPlace: string;
  registrationTypeId: number;
  registrationNumber: string;
  registrationExpireDate: moment;

  functionName: string;
  isDecisionMaker: boolean;
  shares: number;

  companyPersonId: number;
}
